"use client";
import { useState } from "react";
import { useRouter } from "next/navigation";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const router = useRouter();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetch("/engine/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password })
      });

      if (!res.ok) throw new Error("Invalid credentials");

      const data = await res.json();
      
      // --- THE UPGRADE: Store the Real Database ID in the Browser ---
      localStorage.setItem("hms_user_id", data.user_id);
      localStorage.setItem("hms_user_role", data.role);
      
      if (data.role === "admin") router.push("/admin");
      else if (data.role === "evaluator") router.push("/evaluator");
      else if (data.role === "client")// THE TRAFFIC COP ROUTING
        if (data.role === "client") {
          router.push("/client");
        } else if (data.role === "evaluator") {
          router.push("/evaluator");
        } else {
          router.push("/analytics");
        }
      
    } catch (err) {
      setError("Access Denied. Please check your email and password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center font-sans text-white p-4">
      <div className="w-full max-w-md bg-zinc-900 border border-zinc-800 p-8 rounded-xl shadow-2xl">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-black tracking-widest uppercase text-zinc-100 mb-1">HMS Matrix</h1>
          <p className="text-zinc-500 text-sm tracking-wide">Authorized Personnel Only</p>
        </div>
        {error && <div className="bg-red-950/50 border border-red-900 text-red-400 p-3 rounded text-sm mb-6 text-center">{error}</div>}
        <form onSubmit={handleLogin} className="flex flex-col gap-5">
          <div>
            <label className="block text-xs uppercase tracking-widest text-zinc-400 mb-2">Email Address</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-zinc-950 border border-zinc-800 p-3 rounded text-white focus:outline-none focus:border-blue-500" required />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-widest text-zinc-400 mb-2">Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-zinc-950 border border-zinc-800 p-3 rounded text-white focus:outline-none focus:border-blue-500" required />
          </div>
          <button type="submit" disabled={loading} className="w-full bg-blue-600 hover:bg-blue-500 text-white font-bold p-3 rounded uppercase tracking-widest mt-2 transition-colors disabled:opacity-50">
            {loading ? "Authenticating..." : "Establish Connection"}
          </button>
        </form>
      </div>
    </div>
  );
}
